import api from "./axios";

// Create Stripe checkout session for subscription upgrade
export const createCheckoutApi = async (plan: string, cycle: string = "monthly") => {
  const response = await api.post("/api/billing/checkout", { 
    plan, 
    cycle 
  });
  console.log("🔍 createCheckoutApi raw response:", response);
  console.log("🔍 response.data:", response.data);
  return response.data;
};

// Verify and create subscription after checkout
export const verifySubscriptionApi = async (sessionId: string) => {
  const response = await api.get(`/api/billing/subscription/verify?session_id=${sessionId}`);
  return response.data;
};

// Create Stripe customer portal session (for managing payment methods, invoices)
export const createPortalApi = async (returnUrl: string) => {
  const response = await api.post("/api/billing/portal", { returnUrl });
  return response.data;
};

// Get current subscription
export const getSubscriptionApi = async () => {
  const response = await api.get("/api/billing/subscription");
  return response.data;
};

// Get credit balance
export const getCreditBalanceApi = async () => {
  const response = await api.get("/api/billing/credits");
  return response.data;
};

// Get credit ledger history
export const getCreditLedgerApi = async () => {
  const response = await api.get("/api/billing/credits/ledger");
  return response.data;
};

// Purchase a credit pack
export const purchaseCreditPackApi = async (amount: number) => {
	const response = await api.post("/api/billing/credits/purchase", { 
		amount: amount
	});
	return response.data;
};

// Get saved payment methods
export const getPaymentMethodsApi = async () => {
  const response = await api.get("/api/billing/payment-methods");
  return response.data;
};

// Remove a saved payment method
export const removePaymentMethodApi = async (paymentMethodId: string) => {
  const response = await api.delete(`/api/billing/payment-methods/${paymentMethodId}`);
  return response.data;
};

// Set a payment method as default
export const setDefaultPaymentMethodApi = async (paymentMethodId: string) => {
  const response = await api.post(`/api/billing/payment-methods/${paymentMethodId}/default`);
  return response.data;
};

// Get billing/invoice history
export const getBillingHistoryApi = async () => {
  const response = await api.get("/api/billing/invoices");
  return response.data;
};
